import { render, staticRenderFns } from "./CloseRequestPasswordComponent.vue?vue&type=template&id=c4223424&scoped=true"
import script from "./CloseRequestPasswordComponent.vue?vue&type=script&lang=js"
export * from "./CloseRequestPasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./CloseRequestPasswordComponent.vue?vue&type=style&index=0&id=c4223424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4223424",
  null
  
)

export default component.exports